import PropTypes from 'prop-types';
import React from 'react';
import {
    ComboBox,
    ComposedModal,
    Button,
    FormGroup,
    FormLabel,
    DropdownSkeleton,
    TextArea,
    TextInputSkeleton,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from 'carbon-components-react';
import moment from 'moment';
import { Online, Offline } from '../common/OnLineOffLine';
import { PlannedWeekChangeType } from '../../helpers/Constants';
import '../../scss/weekSelector.scss';

const EDrillPlanModificationModal = (props) => {
  const isConfirmButtonDisabled = () => (props.approver === null || props.approver === undefined);

  const onSave = async () => {
    await props.onConfirm();
  };

   const renderWeek = (x) => (x === null || x === undefined)
        ? ''
        : `Week: ${x?.weekNumber} | ${moment
            .utc(x?.weekStart)
            .format('DD/MM/YY')} - ${moment
            .utc(x?.weekFinish)
            .format('DD/MM/YY')} +
             | N\u00B0 of Drill: ${x?.quantity} - # ${x?.sequence}`;

  return (
    <ComposedModal
      className="light-modal box-medium-modal"
      open={props.onShow}
      danger="false"
      onClose={() => false}
    >
      <ModalHeader
        className="margin-modal"
        title="Request Drill Plan Modification"
        iconDescription="Close"
        buttonOnClick={props.onCancel}
      />

      <ModalBody className="margin-modal">
        <div>
          <FormLabel className="some-class">Data Approver*</FormLabel>
          {props.isLoadingOperation ? (
            <DropdownSkeleton />
            ) : (
              <ComboBox
                id="combo-approval"
                className="selection-items-list-costum"
                placeholder="Select Data Approver"
                items={props.approvers}
                itemToString={(item) =>
                  item
                    ? `${item.name}  ${item.surname} (${item.email})`
                    : ''
                }
                itemToElement={(item) =>
                  item
                    ? `${item.name}  ${item.surname} (${item.email})`
                    : ''
                }
                onChange={({ selectedItem }) =>
                  props.onApproverSelect(selectedItem)
                }
              />
            )
          }
        </div>

        {props.plannedWeekToDelete ? (props.plannedWeekToDelete.map((e, index) => (
          <div key={e.id}>
            
            {props.isLoadingOperation ? (
              <TextInputSkeleton hideLabel />
              ) : (
                <FormGroup legendText="">
                  <FormLabel className="some-class">
                    Drill Deletion 
                    <span className="weekSelector"><span className="tag-item">{renderWeek(e)}</span></span>
                  </FormLabel>
                  <TextArea
                    maxLength={5000}
                    id={e.id}
                    placeholder="Reason for change"
                    value={e.reasonForChange || ''}
                    labelText="Reason for change*"
                    light
                    onChange={(el) => props.onUpdateReasonForChange(PlannedWeekChangeType.ToDelete, el)}
                    rows={4}
                    cols={225}
                    invalid={props.validations.toDelete[index] ? true : false}
                  />
                  {props.validations.toDelete[index]}
                </FormGroup>
              ) }
            
          </div>
          ))) : null
        }
        {props.plannedWeekToUpdate ? (props.plannedWeekToUpdate.map((e, index) => (
          <div key={e.id}>
            
            {props.isLoadingOperation ? (
              <TextInputSkeleton hideLabel />
              ) : (
                <FormGroup legendText="">
                  <FormLabel className="some-class">
                    Drill Modification 
                    <span className="weekSelector"><span className="tag-item">{renderWeek(e)}</span></span>
                  </FormLabel>
                  <TextArea
                    maxLength={5000}
                    id={e.id}
                    placeholder="Reason for change"
                    value={e.reasonForChange || ''}
                    labelText="Reason for change*"
                    light
                    onChange={(el) => props.onUpdateReasonForChange(PlannedWeekChangeType.ToChange, el)}
                    rows={4}
                    cols={225}
                    invalid={props.validations.toUpdate[index] ? true : false}
                  />
                  {props.validations.toUpdate[index]}
                </FormGroup>
              ) }
            
          </div>
          ))) : null
        }
        {props.plannedWeekToAdd ? (props.plannedWeekToAdd.map((e, index) => (
          <div key={e.id}>
            {props.isLoadingOperation ? (
              <TextInputSkeleton hideLabel />
              ) : (
                <FormGroup legendText="">
                  <FormLabel className="some-class">
                    Drill Addition 
                    <span className="weekSelector"><span className="tag-item">{renderWeek(e)}</span></span>
                  </FormLabel>
                  <TextArea
                    maxLength={5000}
                    id={e.id}
                    placeholder="Reason for change"
                    value={e.reasonForChange || ''}
                    labelText="Reason for change*"
                    light
                    onChange={(el) => props.onUpdateReasonForChange(PlannedWeekChangeType.ToAdd, el)}
                    rows={4}
                    cols={225}
                    invalid={props.validations.toAdd[index] ? true : false}
                  />

                  {props.validations.toAdd[index]}
                </FormGroup>
              ) }
          </div>
          ))) : null
        }
      </ModalBody>
      <ModalFooter>
        <Button
          className="button--max-width"
          kind="secondary"
          onClick={props.onCancel}
        >
          Cancel
        </Button>
        <Online>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={() => onSave()}
            disabled={isConfirmButtonDisabled()}
          >
            Confirm
          </Button>
        </Online>
        <Offline>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={() => onSave()}
            disabled
          >
            Confirm
          </Button>
        </Offline>
      </ModalFooter>

    </ComposedModal>
  );
};

EDrillPlanModificationModal.propTypes = {
  plannedWeekToDelete: PropTypes.array,
  plannedWeekToAdd: PropTypes.array,
  plannedWeekToUpdate: PropTypes.array,
  approvers: PropTypes.array.isRequired,
  approver: PropTypes.object,
  isLoadingOperation: PropTypes.bool.isRequired,
  onShow: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onApproverSelect: PropTypes.func.isRequired,
  onUpdateReasonForChange: PropTypes.func.isRequired
};

export default EDrillPlanModificationModal;
